import { IMongoDocument } from "@/types"
import { IEffect } from "../effectsAPI"

export enum ICardSubtype {
  MACHINE = "machine",
  REGULAR = "regular"
}

export enum ICardTier {
  NORMAL = "normal",
  GOLD = "gold"
}

export enum CARD_TYPE {
  WORM = "worm",
  SAND_MOLE = "sand_mole",
  BOWELS_CLAW = "bowels_claw",
  FIRE_TRACE = "fire_trace",
  DEPTHS_CLAW = "depths_claw",
  DOPPELGANGER = "doppelganger",
  TROLL = "troll",
  WORK_ANT = "work_ant",
  DEVASTATION = "devastation",
  RUNE_WELL = "rune_well",
  SINKHOLE = "sinkhole",
  EARTHQUAKE = "earthquake",
  LANDSLIDE = "landslide",
  SANDSTORM = "sandstorm",
  COLLAPSE = "collapse",
  SILENCE_RUNES = "silence_runes",
  SPARK = "spark",
  MECH_MOLE = "mech_mole",
  CRASH = "crash",
  HUMMER_DRILL = "hummer_drill",
  ZOMBIE = "zombie",
  PLUNDER = "plunder",
  FLUFFY = "fluffy",
  DROUGHT = "drought",
  LUCK_RUNES_ECHO = "luck_runes_echo",
  ROCK_FALL = "rock_fall",
  DRILLER = "driller",
  QUICKSAND = "quicksand",
  DISCHARGE = "discharge",
  ICE_PAWN = "ice_pawn",
  TNT = "tnt",
  SENSES = "senses",
  SIXTH_SENSE = "sixth_sense",
  STONEBREAKER = "stonebreaker",
  CLEANSING = "cleansing",
  LITTLE_MISCHIEF = "little_mischief",
  RUNE_MASTER = "rune_master",
  HEADWIND = "headwind",
  SLEIGHT_OF_HAND = "sleight_of_hand",
  STONE_WALL = "stone_wall",
  GIANT_WORM = "giant_worm"
}

export interface ICard extends IMongoDocument {
  type: CARD_TYPE
  currency: "speed" | "luck" | "stamina"
  price: number
  description: string
  imgSrc: string
  effects: IEffect[]
  tier: ICardTier
  subType: ICardSubtype
}

export interface IDeckHandCard extends IMongoDocument {
  player: string
  session: string
  card: ICard
}

export type IDeckHandResponse = IDeckHandCard[]
